import { connect } from 'react-redux'

import OrderPartyModal from './OrderPartyModal'
import { show, types } from 'store/modals'
import { trackEvent } from 'utils/firebase'

const withContainer = connect(null, dispatch => ({
  handleEmailLoginClick: () => dispatch(show(types.LOGIN_V2)),
  show,
  types,
  trackEvent,
}))

export default withContainer(OrderPartyModal)
